import { useState } from 'react';
import HtmlToDmBMapper from '../../mappers/HtmlToDmBMapper';
import { generateUniqueId } from '../../constants';

// Strip all elements but the main
function stripElements(htmlString) {

    
    const div = document.createElement('div');
    div.innerHTML = htmlString;
    // Find the <section class="atf" role="complementary">
    const section = div.querySelector('section.primary-content[role="main"]');
    // Clear the container and append only the found section (if any)
    div.innerHTML = '';
    if (section) {
        div.appendChild(section.cloneNode(true));
    }

    let removeSelectors = [{tag: 'script'}, {tag: 'style'}, {tag: 'div.homebrew-comments'}]
    removeSelectors.forEach(selector => {
        div.querySelectorAll(selector.tag).forEach(el => el.remove());
    });

    return div.innerHTML;
}

const ImportHtml = ({setCurrentEncounter, encounterGuid, socket}) => {
    const [html, setHtml] = useState('')

    const validate = (e) => {
        setHtml(e.target.value)
    }

    const sendUpdate = () => {
        const eGuid = encounterGuid || generateUniqueId();
        let cleanedHtml = stripElements(html);
      
        setHtml(cleanedHtml)
        
        // Send the whole monsters object since it comes with hp data
        // const dmbMonsters = await ImportDndBeyondMonsters(monsters, eGuid);
        setCurrentEncounter(prev => {
            // if(prev.creatures.length === 0 && prev.encounterName === INIT_ENCOUNTER_NAME) {
            //     socket.emit("newEncounter", eGuid, data.data.name, prev.folder_dir)
            // }

            // socket.emit("importedDndBCreatures", validPlayers, username);
            return {
                ...prev,
                encounterGuid: eGuid,
                encounterName: prev.encounterName,
                creatures: [...prev.creatures, HtmlToDmBMapper(cleanedHtml)]
            };
        });
        
        console.log("Creatures Imported!")
    }

    return (
        <div className='editHpGrow'>
            <div className="notesWidgetFlag"/>
            <div className="notesContainer">
                <div className="editBlockTitle"><i>Import Html</i></div>
                <hr className="editlineSeperator"/>
                <textarea
                    className="editNotesInput"
                    type="text"
                    value={html}
                    onChange={(e) => validate(e)} 
                    onBlur={(e) => sendUpdate()} 
                />  
            </div>
        </div>
    )
}

export default ImportHtml;